export const SIMPLE_CAROUSEL_ARROW = {
  prev: 'prev',
  next: 'next',
} as const;

export type SimpleCarouselArrow = typeof SIMPLE_CAROUSEL_ARROW[keyof typeof SIMPLE_CAROUSEL_ARROW];
